import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { woundAssessmentReEvalAsync, ne1updateassessmentsignlockAsync } from "../../../../app/patientSlice";
import { lockSuccessAsyncData } from "../../../../utils/patientsHelper";
import { DISCHARGED } from "../../../../constants";
import { usePermissions } from "../../../../hooks/usePermissions";
import { getSignButtonStatus } from "../../../../utils/getSignButtonStatus";
import { useLoading } from "../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../constants/loadingKeys";

export const MODAL_TYPES = {
  LOCK: "LOCK",
  RE_EVAL: "RE_EVAL",
};

export const useSignAndLock = () => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();
  const { hasPermission } = usePermissions();

  const signAndLockLoading = useLoading(LOADING_KEYS.SIGN_LOCK_LOADING);

  const detailViewData = useSelector((state) => state.patient.detailViewData);
  const minimumDatasetInfo = useSelector((s) => s.patient.minimumDatasetInfo);
  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);

  const { isSign, pendingItems } = getSignButtonStatus(detailViewData?.signCriteria, minimumDatasetInfo, assessmentDetail?.signWithOutMinimumDataset);

  const signed = assessmentDetail?.signed === 1;
  const locked = assessmentDetail?.locked === 1;
  const isDischarged = detailViewData?.statusInfo?.status === DISCHARGED;

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [isSignAndLock, setIsSignAndLock] = useState(false);

  // Dropdown state
  const [viewDrop, setViewDrop] = useState(false);
  const dropRef = useRef();

  const modalOpen = (e, type) => {
    e.preventDefault();
    setModalType(type);
    setShowModal(true);
  };

  const modalClose = () => {
    setShowModal(false);
  };

  const handleSign = (e) => {
    e.preventDefault();
    setViewDrop(false);

    const assessment = {
      ...assessmentDetail,
      assessmentStage: "pendingreview",
      signed: 1,
    };
    const payload = { patientId, assessmentId, assessment };
    dispatch(ne1updateassessmentsignlockAsync(payload));
    modalClose();
  };

  const handleContinue = (e) => {
    modalClose();
    lockSuccessAsyncData(assessmentDetail, patientId, assessmentId, dispatch, ne1updateassessmentsignlockAsync, isSignAndLock);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setViewDrop((prev) => !prev);
  };

  const handleReEval = (e) => {
    e.preventDefault();
    const payload = { patientId, assessmentId };
    dispatch(woundAssessmentReEvalAsync(payload));
  };

  const handleReEvalMsg = (e) => {
    e.preventDefault();
    modalOpen(e, MODAL_TYPES.RE_EVAL);
  };

  const handleContinueReEval = (e) => {
    modalClose();
    handleReEval(e);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) {
        setViewDrop(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return {
    // Derived from store
    signed,
    locked,
    isDischarged,
    isSign,
    pendingItems,
    signAndLockLoading,
    assessmentDetail,
    detailViewData,
    // Permissions
    hasPermission,
    // Modal
    showModal,
    modalType,
    modalOpen,
    modalClose,
    // Dropdown
    viewDrop,
    dropRef,
    handleDrop,
    // Sign & lock control
    isSignAndLock,
    setIsSignAndLock,
    // Handlers
    handleSign,
    handleContinue,
    handleReEval,
    handleReEvalMsg,
    handleContinueReEval,
  };
};
